export default __webpack_public_path__ + "static/media/mascote-cabeca.a4ef4dab.webp";